import {
  useAuth0 as useAuth0Original,
  withAuthenticationRequired as withAuthenticationRequiredOriginal,
  WithAuthenticationRequiredOptions,
} from "@auth0/auth0-react";
import React from "react";

export const useAuth0 = () => {
  const auth0 = useAuth0Original();

  const isTestMode =
    typeof window !== "undefined" &&
    (window as Window & { __PLAYWRIGHT_TEST__?: boolean }).__PLAYWRIGHT_TEST__;

  if (isTestMode) {
    return {
      isAuthenticated: true,
      isLoading: false,
      user: {
        sub: "test-user",
        email: "test@example.com",
        name: "Test User",
        picture: "https://example.com/avatar.jpg",
      },
      getAccessTokenSilently: () => Promise.resolve("mock-token"),
      getIdTokenClaims: () => Promise.resolve({ __raw: "mock-id-token" }),
      loginWithRedirect: () => {},
      logout: () => {},
      buildAuthorizeUrl: () => Promise.resolve("mock-url"),
      buildLogoutUrl: () => "mock-logout-url",
    };
  }

  return auth0;
};

export const withAuthenticationRequired = (
  Component: React.ComponentType<Record<string, unknown>>,
  options?: WithAuthenticationRequiredOptions
) => {
  const isTestMode =
    typeof window !== "undefined" &&
    (window as Window & { __PLAYWRIGHT_TEST__?: boolean }).__PLAYWRIGHT_TEST__;

  if (isTestMode) {
    return () => React.createElement(Component);
  }

  return withAuthenticationRequiredOriginal(Component, options);
};
